import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  AnnualTurnover,
  MdrDetails,
  OLIDetail,
  POSProduct,
  PlanDetail,
  Slab,
} from 'models/productsV3.model'
import { combineProductsList } from 'pages/ProductsCatalog/utils'

interface ProductsPayload {
  productsList: POSProduct[]
  selectedProductsList: OLIDetail[]
}
interface UpdateMDRPayload {
  planId: number
  vasRefId: string
  mdrId?: number
  value?: number
  cardNetwork: string
  instrumentName: string
  rateType: string
  lowerLimit: number
  upperLimit: number
  lowerLimitAmount: number
  upperLimitAmount: number
  capAmount: number
  sellRate: number
}

interface ProductsState {
  selectedProducts: OLIDetail[]
  allProducts: POSProduct[]
  isObsolete: boolean
  localSelectedProducts: SelectedProduct[]
  customFeesMapping: any
  productPlanMapping: any
  mdrDetails?: UpdateMDRPayload[]
}

export interface SelectedProduct {
  //  planId?: string
  // productId?: string
  quantity: number
  name?: string
  id?: number
  planId: number
  downstreamPlanId?: string
  excluded?: boolean
  hasChanged?: boolean
}

const initialState: ProductsState = {
  selectedProducts: [],
  localSelectedProducts: [],
  allProducts: [],
  isObsolete: false,
  customFeesMapping: {},
  productPlanMapping: {},
  mdrDetails: [],
}
interface AddUpdateProductPayload {
  planId: number
  productId: string
  quantity: number
  name: string
}
interface MergeApiPayload {
  planList: PlanDetail[]
  planId?: number
}
interface AddUpdateProductListPayload {
  planList: PlanDetail[]
  quantity?: number
  planId?: number
  isRemove?: boolean
  productId?: number
}
interface AddUpdateProductCustomPricingPayload {
  planId: number
  productId: number
  customPricing: {
    [feeId: number]: {
      customValue: string
      pricingType: string
    }
  }
}

const productsSlice = createSlice({
  name: 'productsV3',
  initialState,
  reducers: {
    setProducts: (state: ProductsState, action: PayloadAction<ProductsPayload>) => {
      const { payload } = action
      if (payload?.productsList && payload?.selectedProductsList) {
        const { productsList, selectedProductsList } = payload
        state.selectedProducts = selectedProductsList
        state.localSelectedProducts = []
        state.allProducts = combineProductsList({ productsList, selectedProductsList })
        // --- Hydrate customFeesMapping from API response for reload persistence ---
        state.customFeesMapping = {}
        state.allProducts.forEach((product: any) => {
          // If product has plans array, hydrate for each plan
          if (Array.isArray(product.plans)) {
            product.plans.forEach((plan: any) => {
              const planKey = String(plan.planId ?? plan.id)
              const productKey = String(plan.id)
              if (!state.customFeesMapping[planKey]) state.customFeesMapping[planKey] = {}
              if (plan.customAdvancedMonth !== undefined && plan.pricingType === 'Custom Pricing') {
                state.customFeesMapping[planKey][productKey] = {
                  customAdvancedMonth: plan.customAdvancedMonth,
                  pricingType: plan.pricingType,
                }
              }
            })
          }
          // Also hydrate for the product itself (flat plan case)
          const planKey = String(product.planId ?? product.id)
          const productKey = String(product.id)
          if (!state.customFeesMapping[planKey]) state.customFeesMapping[planKey] = {}
          if (
            product.customAdvancedMonth !== undefined &&
            product.pricingType === 'Custom Pricing'
          ) {
            state.customFeesMapping[planKey][productKey] = {
              customAdvancedMonth: product.customAdvancedMonth,
              pricingType: product.pricingType,
            }
          }
        })
      }
      console.log('selectedProducts xx = ' + JSON.stringify(state.selectedProducts))
      state.isObsolete = false
    },

    mergeApiPlansWithLocal: (state: ProductsState, action: PayloadAction<MergeApiPayload>) => {
      const { planId, planList } = action.payload
      const prevCart = state?.localSelectedProducts

      const workingCart = [...prevCart]

      planList?.forEach(({ id, name, quantity, downstreamPlanId }: PlanDetail) => {
        const excluded = quantity === 0
        const hasChanged = false
        const existingIndex = workingCart.findIndex(
          (item) => item.id === id && item.planId === planId,
        )

        if (existingIndex === -1 || workingCart.length === 0) {
          workingCart.push({ id, planId, downstreamPlanId, name, quantity, excluded, hasChanged })
        } else if (existingIndex >= 0) {
          const existingItem = workingCart[existingIndex]
          const updatedItem = { ...existingItem, quantity, hasChanged }
          workingCart[existingIndex] = updatedItem
        }
      })
      state.localSelectedProducts = workingCart
      console.log('mergeApiPlansWithLocal = ' + JSON.stringify(state?.localSelectedProducts))
    },

    addOrUpdatePlanByList: (
      state: ProductsState,
      action: PayloadAction<AddUpdateProductListPayload>,
    ) => {
      const { planId, planList, quantity, isRemove } = action.payload
      const prevCart = state?.localSelectedProducts
      const hasChanged = true
      console.log('addOrUpdate prevCart = ' + prevCart.length)
      console.log(
        'addOrUpdate planId = ' +
        planList?.length +
        ', quantity = ' +
        quantity +
        ', isRemove' +
        isRemove,
      )

      const workingCart = [...prevCart]

      planList?.forEach(({ id, name, downstreamPlanId }: PlanDetail) => {
        const existingIndex = workingCart.findIndex(
          (item) => item.id === id && item.planId === planId,
        )

        if (existingIndex === -1 || workingCart.length === 0) {
          workingCart.push({ id, planId, downstreamPlanId, name, quantity, hasChanged })
        } else if (existingIndex >= 0) {
          const existingItem = workingCart[existingIndex]
          const updatedItem = { ...existingItem, quantity, hasChanged }
          if (!updatedItem?.excluded) {
            console.log('prevdebug2 = ' + JSON.stringify(updatedItem))
            workingCart[existingIndex] = updatedItem
          }
        }
      })
      state.localSelectedProducts = workingCart

      // Remove items with quantity 0
      if (!isRemove)
        state.localSelectedProducts = workingCart.filter(
          (item) => item.quantity > 0 || item?.excluded,
        )
      else {
        state.localSelectedProducts = workingCart
      }
      // Assign once
      // state.localSelectedProducts = workingCart
      // console.log('updatedProducts = ' + JSON.stringify(workingCart))

      console.log('locallySelected = ' + JSON.stringify(state?.localSelectedProducts))
    },

    removeProduct: (state: ProductsState, action: PayloadAction<AddUpdateProductListPayload>) => {
      const { planId, planList, quantity, productId, isRemove } = action.payload
      const prevCart = state?.localSelectedProducts
      console.log('addOrUpdate prevCart = ' + prevCart.length + ', isRemove = ' + isRemove)

      const workingCart = [...prevCart]

      const updatedCart = workingCart.map((item) => {
        if (item.planId === planId && item.id === productId) {
          return {
            ...item,
            quantity: isRemove ? 0 : quantity,
            excluded: isRemove ? true : false,
            hasChanged: true,
          }
        }
        return item
      })
      state.localSelectedProducts = updatedCart

      console.log('locallySelected = ' + JSON.stringify(state?.localSelectedProducts))
    },

    setProductPlanMapping: (state: ProductsState, action: PayloadAction<Array<PlanDetail>>) => {
      const plans = action.payload
      plans?.map((item) => {
        state.productPlanMapping[item?.id] = item
      })
      console.log('state.productPlanMapping = ' + JSON.stringify(state.productPlanMapping))
    },
    updateMDRDetails: (state: ProductsState, action: PayloadAction<UpdateMDRPayload>) => {
      const existingData = state.mdrDetails || []
      // Keys to compare (excluding 'sellRate')
      const newItem = action.payload
      const keysToCompare = Object.keys(newItem).filter(
        (key) => key !== 'sellRate' && key !== 'value',
      )

      // Find the index of the matching item
      const index = existingData.findIndex((item) =>
        keysToCompare.every((key) => item[key] === newItem[key]),
      )

      if (index !== -1) {
        // Update the existing item
        const updatedArray = [...existingData]
        updatedArray[index] = newItem
        state.mdrDetails = updatedArray
      } else {
        // Add new item
        state.mdrDetails = [...existingData, newItem]
      }
    },
    markObsolete: (state: ProductsState) => {
      state.isObsolete = true
    },
    clearLocalProducts: (state: ProductsState) => {
      state.productPlanMapping = {}
      state.localSelectedProducts = []
    },
    clearProducts: () => {
      return initialState
    },
    addOrUpdatePlanCustomPricing: (
      state: ProductsState,
      action: PayloadAction<
        AddUpdateProductCustomPricingPayload & { customAdvancedMonth?: number }
      >,
    ) => {
      const { planId, productId, customPricing, customAdvancedMonth } = action.payload
      if (!state.customFeesMapping[planId]) {
        state.customFeesMapping[planId] = {}
      }
      if (!state.customFeesMapping[planId][productId]) {
        state.customFeesMapping[planId][productId] = {}
      }
      state.customFeesMapping[planId][productId].customPricing = customPricing
      if (customAdvancedMonth !== undefined) {
        state.customFeesMapping[planId][productId].customAdvancedMonth = customAdvancedMonth
        state.customFeesMapping[planId][productId].pricingType = 'Custom Pricing'
      }
      // If any customPricing is present, also set pricingType
      if (customPricing && Object.keys(customPricing).length > 0) {
        state.customFeesMapping[planId][productId].pricingType = 'Custom Pricing'
      }
    },
  },
})

function isAnnualTurnoverMatch(
  existingTurnover: AnnualTurnover[],
  newTurnover: AnnualTurnover[],
): boolean {
  return existingTurnover.every((et) =>
    newTurnover.some(
      (nt) =>
        et.capAmount === nt.capAmount &&
        et.lowerLimitAmount === nt.lowerLimitAmount &&
        et.upperLimitAmount === nt.upperLimitAmount &&
        et.rate === nt.rate &&
        et.rateType === nt.rateType,
    ),
  )
}

export const {
  setProducts,
  markObsolete,
  clearProducts,
  setProductPlanMapping,
  addOrUpdatePlanByList,
  clearLocalProducts,
  updateMDRDetails,
  addOrUpdatePlanCustomPricing,
  removeProduct,
  mergeApiPlansWithLocal,
} = productsSlice.actions

export default productsSlice.reducer
